import React from 'react';
import { Chart, registerables } from 'chart.js'; 
import 'chartjs-adapter-date-fns';

Chart.register(...registerables);

function LineChart({ data, options }) {
  // Get the chart context
  const canvasRef = React.useRef(null);
  const chartRef = React.useRef(null);

  React.useEffect(() => {
    if (!data || !canvasRef.current) {
      return;
    }

    const ctx = canvasRef.current.getContext('2d');

    // Create a gradient
    const gradient = ctx.createLinearGradient(0, 0, 0, 400);
    gradient.addColorStop(0, 'rgba(211, 109, 87, 0.3)'); // Color at the top
    gradient.addColorStop(1, 'rgba(211, 109, 87, 0)'); // Color at the bottom (transparent)

    // Update the chart data
    const chartData = {
      labels: Object.keys(data),
      datasets: [
        {
          label: 'Number of Registered Users',
          data: Object.values(data),
          fill: true,
          backgroundColor: gradient,
          borderColor: 'rgba(211, 109, 87, 1)',
          tension: 0.5,
        },
      ],
    };

    // Update the chart
    if (chartRef.current) {
      chartRef.current.data = chartData;
      chartRef.current.update();
    } else {
      chartRef.current = new Chart(ctx, {
        type: 'line',
        data: chartData,
        options: options,
      });
    }
  }, [data, options]);

  return <canvas ref={canvasRef} />;
}

export default LineChart;
